import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for L303 (正式發行文件一覽)
// ============================================================

export interface ReportRequest {
  docNoFrom?: string;      // FL030_01 文件編號起始
  docNoTo?: string;        // FL030_01 文件編號結束
  docType?: number;        // FL030_16 文件類型 0=全部/1/2/3
  categoryCode?: string;   // FL030_17 文件類別代碼
}

export interface ReportItem {
  fl030_01: string;        // 文件編號
  fl030_11: string;        // 文件名稱
  fl030_12: string | null; // 制訂日期
  fl030_13: string | null; // 修訂日期
  fl030_14: string;        // 代碼
  fl030_15: number;        // 版次
  fl030_16: number;        // 文件類型
  fl030_17: string;        // 文件類別代碼
  fl030_79: boolean;       // 布林旗標
  fl030_80: string;        // 狀態
  category_name: string;   // 類別名稱
}

export interface ReportResponse {
  items: ReportItem[];
  total: number;
}

// ============================================================
// API methods
// ============================================================

export const l303Api = {
  /** Query document listing records with optional filters */
  async getReport(params: ReportRequest): Promise<ReportResponse> {
    const query: Record<string, string> = {};
    if (params.docNoFrom?.trim()) query['docNoFrom'] = params.docNoFrom.trim();
    if (params.docNoTo?.trim()) query['docNoTo'] = params.docNoTo.trim();
    if (params.docType !== undefined && params.docType > 0) query['docType'] = String(params.docType);
    if (params.categoryCode?.trim()) query['categoryCode'] = params.categoryCode.trim();
    const res = await apiClient.get('/api/l303/report', { params: query });
    return res.data;
  },
};
